<template>
    <v-card class="w100p round-card background-2" :class="{'mb-12': inDialog}" :elevation="inDialog ? 0 : 1">
        <v-card-title class="pa-3">
            <p class="pl-2 pl-xl-3">{{ title }}</p>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-toolbar-items v-if="filter">
                <v-switch v-if="filter"
                    style="padding-top: 0 !important; margin: auto !important"
                    label="Nascondi completati"
                    v-model="filterSet['hide_product_saleorder_completed']"
                    hide-details
                    inset
                    color="primary"
                ></v-switch>
            </v-toolbar-items>
            <!-- Storico prodotti ordinati dal cliente (drawer, solo ordini di vendita) -->
            <template v-if="showHistoryButton">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            class="ml-4 d-md-none"
                            @click="$emit('open-history')">
                            <v-icon>history</v-icon>
                        </v-btn>
                    </template>
                    <span>Storico prodotti ordinati dal cliente</span>
                </v-tooltip>
                <!-- Versione con testo per schermi grandi -->
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="ml-4 d-none d-md-flex"
                            @click="$emit('open-history')"
                            outlined>
                            <v-icon left>history</v-icon>
                            Storico
                        </v-btn>
                    </template>
                    <span>Storico prodotti ordinati dal cliente</span>
                </v-tooltip>
            </template>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        class="ml-4 d-md-none"
                        @click="toggleBulkActions"
                        :color="showBulkActions ? 'primary' : 'default'">
                        <v-icon>mdi-file-cog-outline</v-icon>
                    </v-btn>
                </template>
                <span>Azioni rapide</span>
            </v-tooltip>
            <!-- Versione con testo per schermi grandi -->
            <v-btn
                class="ml-4 d-none d-md-flex"
                @click="toggleBulkActions"
                :color="showBulkActions ? 'primary' : 'default'"
                outlined>
                <v-icon left>mdi-file-cog-outline</v-icon>
                Azioni rapide
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        
        <!-- Expansion Panel per Azioni Rapide -->
        <v-expand-transition>
            <div v-show="showBulkActions" class="pa-2 background-1">
                
                <!-- Azioni generali -->
                <div class="d-flex align-center justify-space-between mb-2">
                    <h5 class="mb-0">Azioni Rapide</h5>
                    <v-btn 
                        color="error" 
                        outlined 
                        @click="clearAllItems"
                        :disabled="items.length === 0">
                        <v-icon small left>mdi-delete-sweep</v-icon>
                        Svuota tutto
                    </v-btn>
                </div>

                <!-- Azioni per campi numerici (prezzi, quantità, sconti) -->
                <div v-if="numericFields.length > 0">
                    <v-divider class="my-2"></v-divider>
                    <div v-for="field in numericFields" :key="field.key" class="mb-1">
                        <v-row dense align="center" class="mx-0">
                            <v-col cols="3" class="pa-1">
                                <strong style="font-size: 12px;">{{ field.label }}</strong>
                            </v-col>
                            <v-col cols="2" class="pa-1">
                                <v-select
                                    v-model="bulkActions[field.key].operation"
                                    :items="numericOperations"
                                    dense
                                    outlined
                                    hide-details
						            :menu-props="{'offset-y': true}"
                                    style="font-size: 12px;"
                                ></v-select>
                            </v-col>
                            <v-col cols="2" class="pa-1">
                                <v-text-field
                                    v-model="bulkActions[field.key].value"
                                    type="number"
                                    step="0.01"
                                    dense
                                    outlined
                                    hide-details
                                    :suffix="field.key.includes('discount') ? '%' : ''"
                                    style="font-size: 12px;"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pa-1">
                                <v-btn 
                                    color="primary" 
                                    @click="applyBulkNumericAction(field.key)"
                                    :disabled="!bulkActions[field.key].value || items.length === 0">
                                    Applica
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <!-- Azioni per campi select/enum -->
                <div v-if="selectFields.length > 0">
                    <v-divider class="my-2"></v-divider>
                    <div v-for="field in selectFields" :key="field.key + '_select'" class="mb-1">
                        <v-row dense align="center" class="mx-0">
                            <v-col cols="3" class="pa-1">
                                <strong style="font-size: 12px;">{{ field.label }}</strong>
                            </v-col>
                            <v-col cols="4" class="pa-1">
                                <v-select
                                    v-model="bulkActions[field.key].selectedValue"
                                    :items="getFieldOptions(field)"
                                    item-text="text"
                                    item-value="value"
                                    dense
                                    outlined
                                    hide-details
                                    clearable
						            :menu-props="{'offset-y': true}"
                                    :placeholder="`${field.label}`"
                                    style="font-size: 12px;"
                                ></v-select>
                            </v-col>
                            <v-col cols="4" class="pa-1">
                                <v-btn 
                                    color="primary" 
                                    @click="applyBulkSelectAction(field.key)"
                                    :disabled="bulkActions[field.key].selectedValue === undefined || items.length === 0">
                                    Applica
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <!-- Azioni per campi boolean -->
                <div v-if="booleanFields.length > 0">
                    <v-divider class="my-2"></v-divider>
                    <div v-for="field in booleanFields" :key="field.key + '_bool'" class="mb-1">
                        <v-row dense align="center" class="mx-0">
                            <v-col cols="3" class="pa-1">
                                <strong style="font-size: 12px;">{{ field.label }}</strong>
                            </v-col>
                            <v-col cols="4" class="pa-1">
                                <v-btn-toggle 
                                    v-model="bulkActions[field.key].booleanValue"
                                    mandatory
                                    dense>
                                    <v-btn small value="true">Sì</v-btn>
                                    <v-btn small value="false">No</v-btn>
                                </v-btn-toggle>
                            </v-col>
                            <v-col cols="4" class="pa-1">
                                <v-btn 
                                    color="primary" 
                                    @click="applyBulkBooleanAction(field.key)"
                                    :disabled="bulkActions[field.key].booleanValue === undefined || items.length === 0">
                                    Applica
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
        </v-expand-transition>
        <v-data-table
            class="round-card background-2 pb-0"
            :headers="fieldDefs"
            :items="filteredItems"
            item-key="id"
            :expanded.sync="expandedItems"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0"
            ref="sortableTable">
            <template v-slot:item="{item, headers, index, expand, isExpanded}">
                <!-- Riga elemento di layout (separator / description / pagebreak) — azioni nella colonna 'actions', contenuto in colspan -->
                <tr v-if="isLayoutElement(item)" :key="itemKey(item)" class="layout-element-row" :class="{ 'cursor-pointer': item.type === 'description' && item.description }">
                    <template v-for="(header, h) in headers">
                        <td v-if="header.value === 'actions'" :class="'text-xs-'+(header.align?header.align:'left')" style="white-space: nowrap; width: 1%;" :key="h">
                            <div class="actions-cell">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon class="mx-0"
                                        :disabled="item.type === 'pagebreak'"
                                        @click.stop="editLayoutElement(index, item)">
                                        <v-icon color="teal">edit</v-icon>
                                    </v-btn>
                                </template>
                                <span>Modifica</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon class="mx-0"
                                        :disabled="item.type === 'pagebreak'"
                                        @click.stop="cloneItem(index, item)">
                                        <v-icon color="blue">content_copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Duplica</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon class="mx-0" @click.stop="deleteItem(index)">
                                        <v-icon color="pink">delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Elimina</span>
                            </v-tooltip>
                            <v-tooltip v-if="showHideInPdfToggle" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon class="mx-0"
                                        :disabled="item.type === 'pagebreak'"
                                        @click.stop="toggleHideInPdf(item)">
                                        <v-icon :color="item.hide_in_pdf ? 'grey' : ''">
                                            {{ !item.hide_in_pdf ? 'mdi-printer' : 'mdi-printer-off' }}
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ !item.hide_in_pdf ? 'Visibile in stampa — click per nascondere' : 'Nascosto in stampa — click per includere' }}</span>
                            </v-tooltip>
                            <v-menu v-if="showLayoutInsertMenu" offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on: onTip, attrs: attrsTip }">
                                            <v-btn v-bind="{...attrs, ...attrsTip}" v-on="{...on, ...onTip}" icon class="mx-0" @click.stop>
                                                <v-icon>mdi-plus-circle-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Inserisci elemento di layout dopo questa riga</span>
                                    </v-tooltip>
                                </template>
                                <v-list dense>
                                    <v-list-item @click="addSeparator(index + 1)">
                                        <v-list-item-icon class="mr-2"><v-icon small>mdi-format-section</v-icon></v-list-item-icon>
                                        <v-list-item-title>Separatore</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="addDescription(index + 1)">
                                        <v-list-item-icon class="mr-2"><v-icon small>mdi-text-box</v-icon></v-list-item-icon>
                                        <v-list-item-title>Descrizione</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="addPagebreak(index + 1)">
                                        <v-list-item-icon class="mr-2"><v-icon small>mdi-format-page-break</v-icon></v-list-item-icon>
                                        <v-list-item-title>Nuova Pagina</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="addSubtotal(index + 1)">
                                        <v-list-item-icon class="mr-2"><v-icon small>mdi-sigma</v-icon></v-list-item-icon>
                                        <v-list-item-title>Subtotale</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            </div>
                        </td>
                        <td v-else-if="header.value === 'drag'" @click="dragStart()" class="handle text-center" :key="h">
                            <v-icon :class="{'drag-disabled': sortableStatus}">drag_handle</v-icon>
                        </td>
                        <td v-else-if="header.value === 'number'" :class="'text-xs-'+(header.align?header.align:'left')" :key="h">
                            {{ index + 1 }}
                        </td>
                        <td v-else-if="isLayoutContentCell(header, headers)" :key="h" :colspan="layoutContentColspan(headers)" class="layout-element-content"
                            @click="item.type === 'description' && item.description ? expand(!isExpanded) : null">
                            <template v-if="item.type === 'separator'">
                                <v-icon small left>mdi-format-section</v-icon>
                                <strong>{{ item.name }}</strong>
                            </template>
                            <template v-else-if="item.type === 'description'">
                                <v-icon small left>mdi-text-box</v-icon>
                                <strong v-if="item.name">{{ item.name }}</strong>
                                <em v-else-if="item.description" class="grey--text">(senza titolo)</em>
                                <em v-else class="grey--text">(descrizione vuota)</em>
                            </template>
                            <template v-else-if="item.type === 'pagebreak'">
                                <v-icon small left>mdi-format-page-break</v-icon>
                                <em class="grey--text">Nuova Pagina</em>
                            </template>
                            <template v-else-if="item.type === 'subtotal'">
                                <div class="d-flex align-center justify-space-between" style="width: 100%;">
                                    <span><v-icon small left>mdi-sigma</v-icon><strong>{{ item.name || 'Subtotale' }}</strong></span>
                                    <div class="d-flex align-center">
                                        <strong>{{ calcSubtotalForRow(index) | currency(2, parent.currency) }}</strong>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on" icon x-small class="ml-2" @click.stop="requestDeleteBlock(index)">
                                                    <v-icon small color="deep-orange">mdi-delete-sweep</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Elimina blocco (opzione + prodotti sopra)</span>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </template>
                        </td>
                    </template>
                </tr>

                <!-- Riga prodotto standard -->
                <tr v-else class="cursor-pointer" :key="itemKey(item)" :class="{ 'row-editing': dialog && index === editedIndex }">
                    <template v-for="(header, h) in headers">
                        <td v-if="header.value === 'actions'" :class="'text-xs-'+(header.align?header.align:'left')" style="white-space: nowrap; width: 1%;" :key="h" @click="item.description ? expand(!isExpanded) : null">
                            <div class="actions-cell">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon class="mx-0" @click.stop="editItem(index, item)">
                                        <v-icon color="teal">edit</v-icon>
                                    </v-btn>
                                </template>
                                <span>Modifica</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon class="mx-0" @click.stop="cloneItem(index, item)">
                                <v-icon color="blue">content_copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Duplica</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon class="mx-0" @click.stop="deleteItem(index)">
                                <v-icon color="pink">delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Elimina</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="showHideInPdfToggle">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon class="mx-0" @click.stop="toggleHideInPdf(item)">
                                        <v-icon :color="item.hide_in_pdf ? 'grey' : ''">
                                            {{ !item.hide_in_pdf ? 'mdi-printer' : 'mdi-printer-off' }}
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ !item.hide_in_pdf ? 'Visibile in stampa — click per nascondere' : 'Nascosto in stampa — click per includere' }}</span>
                            </v-tooltip>
                            <v-menu v-if="showLayoutInsertMenu" offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on: onTip, attrs: attrsTip }">
                                            <v-btn v-bind="{...attrs, ...attrsTip}" v-on="{...on, ...onTip}" icon class="mx-0" @click.stop>
                                                <v-icon>mdi-plus-circle-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Inserisci elemento di layout dopo questa riga</span>
                                    </v-tooltip>
                                </template>
                                <v-list dense>
                                    <v-list-item @click="addSeparator(index + 1)">
                                        <v-list-item-icon class="mr-2"><v-icon small>mdi-format-section</v-icon></v-list-item-icon>
                                        <v-list-item-title>Separatore</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="addDescription(index + 1)">
                                        <v-list-item-icon class="mr-2"><v-icon small>mdi-text-box</v-icon></v-list-item-icon>
                                        <v-list-item-title>Descrizione</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="addPagebreak(index + 1)">
                                        <v-list-item-icon class="mr-2"><v-icon small>mdi-format-page-break</v-icon></v-list-item-icon>
                                        <v-list-item-title>Nuova Pagina</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="addSubtotal(index + 1)">
                                        <v-list-item-icon class="mr-2"><v-icon small>mdi-sigma</v-icon></v-list-item-icon>
                                        <v-list-item-title>Subtotale</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            </div>
                        </td>
                        <td v-else-if="header.value === 'number'" :class="'text-xs-'+(header.align?header.align:'left')" :key="h" @click="item.description ? expand(!isExpanded) : null">
                            {{ index + 1 }}
                        </td>
                        <td v-else-if="header.value === 'drag'" @click="dragStart()" class="handle text-center" :key="h" >
                            <v-icon :class="{'drag-disabled': sortableStatus}">drag_handle</v-icon>
                        </td>
                        <td v-else-if="header.type == 'currency' && !isLayoutElement(item)" :class="['text-xs-'+(header.align?header.align:'left'), header.class]" :key="h" @click="item.description ? expand(!isExpanded) : null">
                            <!-- subtotal: ricalcolo live per reagire al cambio di global_discount nel parent (coerente col footer) -->
                            {{ (header.value === 'subtotal' ? calcItemNetPrice(item) : item[header.value]) | currency(5, parent.currency) }}
                        </td>
                        <td v-else-if="header.type === 'date' && !isLayoutElement(item)" @click="item.description ? expand(!isExpanded) : null" :key="h">
							<div>
								{{ item[header.value] | date }}
							</div>
						</td>
                        <td v-else-if="header.type == 'price_per_pack' && !isLayoutElement(item)" :class="'text-xs-'+(header.align?header.align:'left')" :key="h" @click="item.description ? expand(!isExpanded) : null">
                            {{  item.quantity_per_pack * item.price | currency(5, parent.currency) }}
                        </td>
                        <td v-else-if="header.type == 'chips'" :class="'text-xs-'+header.align" :key="h" @click="item.description ? expand(!isExpanded) : null">
                            <v-chip v-for="(chip, c) in item[header.value]" small :key="c">
                                <template v-if="header.customfield">{{ getChipText(header, chip) }}</template>
								<template v-else>{{ chip }}</template>
                            </v-chip>
                        </td>
                        <td v-else-if="header.type == 'chip'" :class="'text-xs-'+header.align" :key="h" @click="item.description ? expand(!isExpanded) : null">
							<v-chip small v-if="item[header.value]">
								<template v-if="header.customfield">{{ getChipText(header, item[header.value]) }}</template>
								<template v-else>{{ item[header.value] }}</template>
							</v-chip>
						</td>
                        <td v-else-if="header.type == 'boolean'" :class="'text-'+(header.align?header.align:'center')" :key="'bool_'+h" @click="item.description ? expand(!isExpanded) : null">
                            <v-icon small :color="item[header.value] ? 'success' : 'grey'">{{ item[header.value] ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                        </td>
                        <td v-else :class="'text-xs-'+(header.align?header.align:'left')" :key="'def_'+h" @click="item.description ? expand(!isExpanded) : null">
                            {{ item[header.value] }}
                        </td>
                    </template>
                </tr>

            </template>
            <template v-slot:expanded-item="{ item, headers }">
                <tr v-if="item.description" class="expanded-description-row">
                    <td :colspan="headers.length" class="pa-0">
                        <v-card text class="px-4 py-2 elevation-0 background-2">
                            <v-card-text class="pa-0">
                                <div class="description-content" v-html="item.description"></div>
                            </v-card-text>
                        </v-card>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <!-- Toolbar elementi di layout (Separatore / Descrizione / Nuova Pagina) — solo su preventivi con setting abilitata -->
        <v-row
            v-if="$store.getters.checkSettings('quotation_layout_elements') && fieldsset && fieldsset.model_name === 'productquotation'"
            class="ma-0 px-3 pt-2 pb-1"
            style="flex-wrap: wrap;"
        >
            <v-btn small class="mr-2 mb-1" outlined @click="addSeparator()">
                <v-icon left small>mdi-format-section</v-icon>
                Separatore
            </v-btn>
            <v-btn small class="mr-2 mb-1" outlined @click="addDescription()">
                <v-icon left small>mdi-text-box</v-icon>
                Descrizione
            </v-btn>
            <v-btn small class="mr-2 mb-1" outlined @click="addPagebreak()">
                <v-icon left small>mdi-format-page-break</v-icon>
                Nuova Pagina
            </v-btn>
            <v-btn small class="mb-1" outlined @click="addSubtotal()">
                <v-icon left small>mdi-sigma</v-icon>
                Subtotale
            </v-btn>
        </v-row>

        <div class="pa-4" v-show="!footerComponent"></div>
        <v-divider v-show="footerComponent"></v-divider>

        <component
            v-if="footerComponent"
            :is="footerComponent"
            :items="filteredItems"
            :fieldsset="fieldsset.fields"
            :parent="parent"
            :type="'edit'"
            :totals-fields="computedTotalsFields"
            :totals-hidden="computedTotalsHidden"
        ></component>
        
        <v-dialog
            scrollable
            persistent
            v-model="dialog"
            width="1100px"
            :fullscreen="fullScreen || $vuetify.breakpoint.xsOnly">
            <template v-slot:activator="{ on }">
                <v-btn
                    color="primary"
                    v-on="on"
                    dark
                    small
                    absolute
                    bottom
                    left
                    fab
                    :class="{'crud-add-fab--in-dialog': inDialog}"
                    @click.stop.prevent="addNew"
                    >
                    <v-icon>add</v-icon>
                </v-btn>
            </template>
            <v-card v-if="dialog" v-draggable ref="dialogCard" class="background-2" :class="[$vuetify.breakpoint.smAndDown || fullScreen ? 'rounded-0' : 'round-card']">
                <v-card-title class="pa-3 background-1">
				    <p class="pl-2 pl-xl-3">{{ titleDialog }}</p>
                    <v-spacer></v-spacer>
    				<v-tooltip top v-if="typeof editedItem.id == 'undefined'">
						<template v-slot:activator="{ on: tooltip }">					
							<v-btn v-on="{ ...tooltip }" icon @click.native.stop="barcodeScannerMode()">
                                <v-icon>mdi-barcode-scan</v-icon>
                            </v-btn>
						</template>
						<span>Barcode Scanner</span>
    				</v-tooltip>
                    <v-tooltip top>
						<template v-slot:activator="{ on: tooltip }">					
							<v-btn v-on="{ ...tooltip }" icon @click.native.stop="toggleFullScreen">
                                <v-icon>fullscreen</v-icon>
                            </v-btn>
						</template>
						<span>Fullscreen</span>
    				</v-tooltip>                    
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-0">
                    <template v-if="!barcodeScanner">
                        <v-container class="pa-0 pt-4" fluid>
                            <fields-generator
                                :fieldsset.sync="fieldsset"
                                :model="editedItem"
                                ref="fieldsgenerator"
                                :selectChange="updateSelectText"
                                :quantityChange="updateQuantityChange"
                                :mef-import-enabled="mefImportEnabled"
                                :mef-import="mefCatalogImport"
                            ></fields-generator>
                        </v-container>
                        
                        <v-divider v-if="product_warehouse && product_warehouse.collection" class="mt-4"></v-divider>
                        <v-expansion-panels class="pb-1" flat hover v-if="product_warehouse && product_warehouse.collection">
                            <v-expansion-panel class="background-2">
                                <v-expansion-panel-header>
                                    <p class="pl-0">Magazzini</p>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-data-table
                                        class="background-2"
                                        :headers="product_warehouse.info.fieldDefs"
                                        :items="product_warehouse.collection"
                                        :items-per-page="5"
                                        hide-default-footer
                                    ></v-data-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <v-divider class="pt-2 pb-4"></v-divider>
                    </template>
                    <template v-else>
                        <v-container class="pa-0 pt-4" fluid>
                            <v-row class="ma-0">
                                <v-col>
                                    <v-switch
                                        v-model="quantityMode"
                                        label="Richiedi quantità"
                                        inset
                                        hide-details
                                        class="text-center mt-0"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                            <v-row class="ma-0">
                                <v-col class="col-4 pb-0">
                                    <v-text-field
                                        v-model="barcode"
                                        name="barcode"
                                        label="Barcode"
                                        ref="barcode"
                                        dense
                                        class="my-3"
                                        outlined
                                        :hint="!quantityMode ? 'Premi invio per inserire' : ''"
                                        persistent-hint
                                        @keyup.enter="searchProductBarcode"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="col-4 pb-0">
                                    <v-autocomplete v-if="currentBarcodeProduct && currentBarcodeProduct.lots"
                                        label="Lotto"
                                        :items="lotSelect.options"
                                        class="my-3"
                                        :hint="!quantityMode ? 'Premi invio per inserire' : ''"
                                        v-model="barcodeLot"
                                        :menu-props="{maxHeight:'200', nudgeBottom: 3}"
                                        clearable
                                        return-object
                                        item-disabled="barred"
                                        ref="barcodeLot"
                                        :filter="(item, queryText, itemText) => $eventBusUtility.customFilter(item, queryText, itemText, 'subtitle')"
                                        outlined
                                        @change="onLotSelection($event)"
                                        dense>
                                        <template v-slot:selection="data">
                                            <v-chip
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                                small
                                                pill
                                                @click="data.select">
                                                <v-avatar 
                                                    small
                                                    pill
                                                    style="min-width: 24px !important; width: 24px !important; height: 24px !important; border-radius: 50%"
                                                    class="mr-4 v-avatar--left"
                                                    :color="data.item.color ? data.item.color : 'primary'">
                                                    <v-icon class="fs16i" color="white">{{ getIcon(data.item) }}</v-icon>
                                                </v-avatar>				
                                                <div class="xs3 string-cutter" :style="{'max-width': getWidth('lot_id')}">{{ data.item.text }}</div>
                                            </v-chip>
                                        </template>

                                        <template v-slot:item="data">
                                            <template v-if="typeof data.item !== 'object'">
                                                <v-list-item-content v-text="data.item"></v-list-item-content>
                                            </template>
                                            <template v-else>
                                                <v-list-item-avatar v-if="getIcon(data.item)"
                                                    size="32px"
                                                    style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
                                                    class="mr-4"
                                                    :color="data.item.color ? data.item.color : 'primary'">
                                                    <v-icon class="fs18i" :color="data.item.color ? data.item.color : 'white'">{{ getIcon(data.item) }}</v-icon>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                                    <v-list-item-subtitle>
                                                        <span v-for="(key, k) in ['subtitle']" :key="k">{{$trans(data.item[key])}}&nbsp;
                                                        </span>
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </template>
                                        </template>

                                    </v-autocomplete>
                                </v-col>
                                <v-col class="col-2 pb-0" v-if="quantityMode">
                                    <!-- NON usare type="number": il browser scarta le lettere di un
                                         barcode sparato per errore e lascia solo le cifre, trasformando
                                         3LCSKIT013BLACKM in un plausibile 3013. Serve la stringa grezza
                                         per poterla riconoscere e rifiutare in parseBarcodeQuantity() -->
                                    <v-text-field
                                        v-model="barcodeQuantity"
                                        label="Quantità"
                                        ref="quantity"
                                        inputmode="decimal"
                                        :rules="barcodeQuantityRules"
                                        dense
                                        class="my-3"
                                        outlined
                                        :hint="quantityMode ? 'Premi invio per inserire' : ''"
                                        @keyup.enter="addBarcodeProduct"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="col-2 text-center pb-0 mt-3">
                                    <v-btn color="green" :disabled="barcode == ''" @click.native="searchProductBarcode()">Cerca</v-btn>
                                </v-col>
                            </v-row>
                            <v-row class="ma-0">
                                <v-col>
                                    <div v-if="latestBarcodeProduct.name">
                                        <div>
                                            Ultimo prodotto Inserito:
                                        </div>
                                        <div>
                                            Codice: <strong>{{ latestBarcodeProduct.code }}</strong>
                                        </div>
                                        <div>
                                            Nome: <strong>{{ latestBarcodeProduct.name }}</strong>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>

                        </v-container>
                    </template>
                </v-card-text>
                <v-divider class="mt-4"></v-divider>
                <v-card-actions class="px-4 pb-2 background-1" style="padding-bottom: calc(8px + env(safe-area-inset-bottom)) !important;">
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" color="primary" text @click.native="close">Chiudi</v-btn>
                        </template>
                        <span>Esc</span>
                    </v-tooltip>
                    <template v-if="!barcodeScanner">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" color="info" text :loading="loading" @click.native="save(false)">Salva</v-btn>
                            </template>
                            <span>Ctrl + Invio</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" color="green" text :loading="loading" @click.native="save(true)">Salva e Nuovo</v-btn>
                            </template>
                            <span>Ctrl + Shift + Invio</span>
                        </v-tooltip>
                    </template>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Separatore -->
        <v-dialog v-model="separatorDialog" max-width="500px" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card v-if="separatorDialog" v-draggable class="background-2" :class="[$vuetify.breakpoint.smAndDown ? 'rounded-0' : 'round-card']">
                <v-card-title class="pa-3 background-1">
                    <p class="pl-2 pl-xl-3">
                        <v-icon left>mdi-format-section</v-icon>
                        {{ editingLayoutIndex !== null ? 'Modifica Separatore' : 'Aggiungi Separatore' }}
                    </p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-4">
                    <v-text-field
                        v-model="separatorInput"
                        label="Titolo separatore"
                        outlined
                        dense
                        autofocus
                        hide-details
                        @keyup.enter="separatorInput.trim() && confirmSeparator()"
                    ></v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="px-4 pb-2 background-1" style="padding-bottom: calc(8px + env(safe-area-inset-bottom)) !important;">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="separatorDialog = false; separatorInput = ''; editingLayoutIndex = null; pendingInsertIndex = null">Chiudi</v-btn>
                    <v-btn color="info" text :disabled="!separatorInput.trim()" @click="confirmSeparator">{{ editingLayoutIndex !== null ? 'Salva' : 'Inserisci' }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Subtotale -->
        <v-dialog v-model="subtotalDialog" max-width="500px" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card v-if="subtotalDialog" v-draggable class="background-2" :class="[$vuetify.breakpoint.smAndDown ? 'rounded-0' : 'round-card']">
                <v-card-title class="pa-3 background-1">
                    <p class="pl-2 pl-xl-3">
                        <v-icon left>mdi-sigma</v-icon>
                        {{ editingLayoutIndex !== null ? 'Modifica Subtotale' : 'Aggiungi Subtotale' }}
                    </p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-4">
                    <v-text-field
                        v-model="subtotalInput"
                        label="Titolo subtotale (opzionale)"
                        hint="Es. Subtotale Opzione A. Il valore è la somma dei prodotti dal subtotale precedente."
                        persistent-hint
                        outlined
                        dense
                        autofocus
                        @keyup.enter="confirmSubtotal()"
                    ></v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="px-4 pb-2 background-1" style="padding-bottom: calc(8px + env(safe-area-inset-bottom)) !important;">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="subtotalDialog = false; subtotalInput = ''; editingLayoutIndex = null; pendingInsertIndex = null">Chiudi</v-btn>
                    <v-btn color="info" text @click="confirmSubtotal">{{ editingLayoutIndex !== null ? 'Salva' : 'Inserisci' }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog conferma Elimina blocco/opzione -->
        <v-dialog v-model="blockDeleteDialog" max-width="500px" persistent>
            <v-card v-if="blockDeleteDialog && blockDeleteInfo" class="background-2" :class="[$vuetify.breakpoint.smAndDown ? 'rounded-0' : 'round-card']">
                <v-card-title class="pa-3 background-1">
                    <p class="pl-2 pl-xl-3">
                        <v-icon left color="deep-orange">mdi-delete-sweep</v-icon>
                        Elimina blocco
                    </p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-4 body-2">
                    Verranno eliminati <strong>{{ blockDeleteInfo.count }}</strong> {{ blockDeleteInfo.count === 1 ? 'prodotto' : 'prodotti' }}
                    del blocco <strong>«{{ blockDeleteInfo.label }}»</strong> e la relativa riga subtotale.
                    L'eliminazione sarà definitiva al salvataggio del preventivo.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="px-4 pb-2 background-1" style="padding-bottom: calc(8px + env(safe-area-inset-bottom)) !important;">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="blockDeleteDialog = false; blockDeleteInfo = null">Annulla</v-btn>
                    <v-btn color="error" text @click="confirmDeleteBlock">Elimina blocco</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Descrizione (TinyMCE lazy mount) -->
        <v-dialog v-model="descriptionDialog" max-width="800px" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card v-if="descriptionDialog" v-draggable class="background-2" :class="[$vuetify.breakpoint.smAndDown ? 'rounded-0' : 'round-card']">
                <v-card-title class="pa-3 background-1">
                    <p class="pl-2 pl-xl-3">
                        <v-icon left>mdi-text-box</v-icon>
                        {{ editingLayoutIndex !== null ? 'Modifica Descrizione' : 'Aggiungi Descrizione' }}
                    </p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-4">
                    <v-text-field
                        v-model="descriptionTitleInput"
                        label="Titolo (opzionale)"
                        outlined
                        dense
                        hide-details
                        class="mb-3"
                    ></v-text-field>
                    <tinymce-editor
                        editor-id="layout-description-editor"
                        v-model="descriptionInput"
                    />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="px-4 pb-2 background-1" style="padding-bottom: calc(8px + env(safe-area-inset-bottom)) !important;">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeDescriptionDialog">Chiudi</v-btn>
                    <v-btn color="info" text :disabled="!descriptionDialogValid" @click="confirmDescription">{{ editingLayoutIndex !== null ? 'Salva' : 'Inserisci' }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>

    import Vue from 'vue'
    import Sortable from 'sortablejs'
    import InputMixin from '@/mixins/InputMixin'
    import DataTableMixin from '@/mixins/DataTableMixin'
    import FooterProductDocumentTable from '@/components/common/FooterProductDocumentTable.vue'

    export default {
        name: 'crud-table-relationship',
        mixins: [
            InputMixin,
            DataTableMixin
        ],
        components: {
            FooterProductDocumentTable,
        },

        props: {
            filter: Object,
            parent: Object,
            infoUrl: String,
            children: Array,
            footerComponent: String,
            inDialog: {
                type: Boolean,
                default: false
            },
            totalsConfig: {
                type: Object,
                default: null
            },
            // mostra il pulsante "Storico" (drawer storico prodotti del cliente)
            showHistoryButton: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                dialog: false,
                loading: false,
                info: {},
                fieldsset: [],
                items: this.children,
                defaultInput: {},
                editedIndex: -1,
                defaultItem: {},
                editedItem: {},
                dummyId: 0,
                modelForAutocomplete: {},
                product_warehouse: {},
                urlParams: '',
                idDescription: null,
                idSeparator: null,
                idPagebreak: null,
                idSubtotal: null,
                separatorDialog: false,
                separatorInput: '',
                subtotalDialog: false,
                subtotalInput: '',
                blockDeleteDialog: false,
                blockDeleteInfo: null,
                descriptionDialog: false,
                descriptionInput: '',
                descriptionTitleInput: '',
                pendingInsertIndex: null,
                editingLayoutIndex: null,
                fieldssetDescription: [],
                itemKeys: new WeakMap(),
                currentItemKey: 0,
                expandedItems: [],
                filterSet: this.filter,
                sortable: {},
                sortableStatus: false,
                fullScreen: false,
                // barcode scanner mode
                barcodeScanner: false,
                currentBarcodeProduct: {},
                latestBarcodeProduct: {},
                quantityMode: false,
                barcodeQuantity: 1,
                // soglia oltre la quale il valore è certamente un barcode sparato per errore
                // nel campo quantità (EAN-8/EAN-13/UPC hanno almeno 8 cifre)
                maxBarcodeQuantity: 999999,
                barcodeQuantityRules: [
                    value => (value !== '' && value !== null && value !== undefined) || 'Richiesto',
                    value => /^\d+([.,]\d+)?$/.test(String(value).trim()) || 'Inserisci solo un numero',
                    value => Number(String(value).trim().replace(',', '.')) > 0 || 'La quantità deve essere maggiore di 0',
                    value => Number(String(value).trim().replace(',', '.')) <= this.maxBarcodeQuantity || 'Quantità non valida (max ' + this.maxBarcodeQuantity + ')'
                ],
                barcodeLot: null,
                barcode: '',
                audioLoad: null,
                audioError: null,
                lotSelect: {
                    'label': 'Lotto',
                    'options': [],
                    'icon': 'mdi-package-variant-closed',
                },
                autoselectLotClass: [
                    'saleinvoiceproduct',
                    'proformainvoiceproduct',
                    'productsaleorder',
                    'ddtproduct',
                    'productquotation',
                    'interventionproduct',
                ],
                // Righe nominalmente di SCARICO (venduto/consumato): specchia lato client
                // la direzione decisa server-side da RowLotAllocationSyncer::isUnloadRow.
                // Tutto il resto (purchaseddt, purchaseinvoice, purchaseorder, asset, note
                // di credito, ...) è carico/no-check.
                unloadModelNames: [
                    'ddtproduct',
                    'saleinvoiceproduct',
                    'proformainvoiceproduct',
                    'productsaleorder',
                    'productquotation',
                    'interventionproduct',
                    'producttask',
                    'movementddtproduct',
                    'productsubscription',
                ],
                // Documenti del ciclo passivo (acquisto): solo qui i lotti/matricole creati
                // al volo dall'editor allocazioni devono nascere col fornitore del documento
                // (Lot.company_id).
                purchaseDocumentModelNames: [
                    'productpurchaseddt',
                    'purchaseinvoiceproduct',
                    'productpurchaseorder',
                ],
                // Righe in cui proporre l'import dal catalogo MEF con l'opzione MEF
                // "tutti i documenti" attiva: documenti di vendita, di acquisto e interventi
                mefImportModelNames: [
                    'productquotation',
                    'productsaleorder',
                    'ddtproduct',
                    'saleinvoiceproduct',
                    'proformainvoiceproduct',
                    'creditnoteproduct',
                    'debitnoteproduct',
                    'productpurchaseorder',
                    'productpurchaseddt',
                    'purchaseinvoiceproduct',
                    'suppliercreditnoteproduct',
                    'selfinvoiceproduct',
                    'interventionproduct',
                ],
                // Azioni rapide
                showBulkActions: false,
                bulkActions: {},
                numericOperations: [
                    { text: 'Sostituisci con', value: 'replace' },
                    { text: 'Incrementa di', value: 'increment' },
                    { text: 'Decrementa di', value: 'decrement' },
                    { text: 'Incrementa %', value: 'increment_percent' },
                    { text: 'Decrementa %', value: 'decrement_percent' }
                ]
            }
        },

        computed: {
            // Abilita l'import on-demand dal catalogo MEF: se il documento ha come fornitore
            // un'azienda collegata al catalogo MEF (integration_key === 'mef'), oppure in
            // qualsiasi documento se è attiva l'opzione MEF "tutti i documenti"
            mefImportEnabled() {
                if (this.parent && this.parent.integration_key === 'mef') return true

                // confronto case-insensitive: alcune righe hanno model_name maiuscolo (es. DebitnoteProduct)
                return this.$store.getters.isMefImportAnyDocument
                    && !!(this.fieldsset && this.fieldsset.model_name)
                    && this.mefImportModelNames.includes(this.fieldsset.model_name.toLowerCase())
            },

            showLayoutInsertMenu() {
                return !!this.$store.getters.checkSettings('quotation_layout_elements')
                    && !!this.fieldsset
                    && this.fieldsset.model_name === 'productquotation'
            },

            descriptionDialogValid() {
                const title = (this.descriptionTitleInput || '').trim()
                const body = (this.descriptionInput || '').replace(/<[^>]*>/g, '').trim()
                return title.length > 0 || body.length > 0
            },

            showHideInPdfToggle() {
                return !!this.$store.getters.checkSettings('quotation_layout_elements')
                    && !!this.fieldsset
                    && this.fieldsset.model_name === 'productquotation'
            },

            fieldDefs() {
                if (this.info.fieldDefs) {
                    return this.info.fieldDefs.filter(fd => {
                        if (fd.key === 'withholding' && (!this.parent || !this.parent.has_withholding)) return false
                        return true
                    })
                } else {
                    return []
                }
            },

            title() {
                if (this.info.crudRelation) {
                    return this.info.crudRelation.title
                } else {
                    return ''
                }
            },

            titleDialog() {
                if (this.info.crudRelation) {
                    return this.info.crudRelation.titleDialog
                } else {
                    return ''
                }
            },

            filteredItems() {
                // Esclude entry null/undefined (transitorie durante render reattivi / splice) prima di render e calcoli
                const validItems = this.items.filter(item => item != null)
                let filtered = validItems.filter((item) => {
                    if(this.filter && this.filter.hide_product_saleorder_completed) {
                        return item.dispatched_quantity < item.quantity
                    }
                })
                this.sortableStatus = (filtered.length != 0 && filtered.length != validItems.length)
                if(this.sortable.options) {
                    this.sortable.option('disabled', this.sortableStatus)
                }
                return filtered.length > 0 ? filtered : validItems
            },

            preselectLot() {
                return this.$store.getters.checkSettings('lot_preselection_enabled') && this.autoselectLotClass.includes(this.fieldsset.model_name)
            },

            // Computed properties per le azioni rapide
            numericFields() {
                if (!this.fieldsset.fields) return []
                return this.fieldsset.fields.filter(field => {
                    return ['number', 'currency'].includes(field.type) && !field.disabled && !field.hidden
                })
            },

            selectFields() {
                if (!this.fieldsset.fields) return []
                return this.fieldsset.fields.filter(field => {
                    return ['enum', 'generalTypes', 'belongsTo'].includes(field.type) && 
                           field.options && field.options.length > 0 && 
                           !field.disabled && !field.hidden
                })
            },

            booleanFields() {
                if (!this.fieldsset.fields) return []
                return this.fieldsset.fields.filter(field => {
                    return field.type === 'boolean' && !field.disabled && !field.hidden
                })
            },

            computedTotalsFields() {
                return this.totalsConfig && this.totalsConfig.fields ? this.totalsConfig.fields : null
            },

            computedTotalsHidden() {
                return this.totalsConfig && this.totalsConfig.hidden === true
            }
        },

        watch: {
            dialog(val) {
                if (val === true) {
                    // Validations for custom fields
                } else {
                    this.close()
                }
            },

            'editedItem.price': function (newVal, oldVal){
                Vue.set(this.editedItem, 'price_per_pack', (newVal  * this.editedItem.quantity_per_pack).toFixed(3))
            },

            'editedItem.quantity': function (newVal, oldVal){
                if(this.editedItem.quantity  == 0) {
                    Vue.set(this.editedItem, 'price_per_pack', 0)
                } else if(this.editedItem.quantity  == 1) {
                    Vue.set(this.editedItem, 'price_per_pack', (this.editedItem.quantity_per_pack * this.editedItem.price).toFixed(3))
                }
            },

            // Documenti d'acquisto (purchaseorder/purchaseddt): il form edita 'purchase_price',
            // ma footer e totali leggono 'price' (il backend espone price = purchase_price).
            // Allineiamo 'price' all'edit cosi' i totali si ricalcolano al salvataggio della riga.
            // Condizionato al model_name d'acquisto => vendita/ddt/preventivi non entrano qui (impatto zero).
            'editedItem.purchase_price': function (newVal){
                const modelName = this.fieldsset && this.fieldsset.model_name
                if (modelName && modelName.indexOf('productpurchase') === 0) {
                    Vue.set(this.editedItem, 'price', newVal)
                }
            },

            'parent.has_withholding': {
                handler(val) {
                    this.toggleWithholdingField(val)
                    this.items.forEach(item => {
                        Vue.set(item, 'withholding', !!val)
                    })
                },
                immediate: false
            },

            // Watcher per inizializzare le azioni rapide quando fieldsset cambia
            fieldsset: {
                deep: true,
                handler() {
                    this.initializeBulkActions()
                }
            },

            // Watcher per ricalcolare i prezzi dei prodotti percentuali quando cambiano gli altri prodotti
            items: {
                deep: true,
                handler() {
                    this.recalculatePercentageProducts()
                }
            },

        },

        created() {
            this.initialize()
            this.initializeBulkActions()
        },
        
        mounted() {
            document.addEventListener('keydown', this.handleShortcut)

            this.sortable = new Sortable(
                this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
                {
                    handle: '.handle',
                    animation: 200,
                    easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                    scrollSensitivity: 60,
                    scrollSpeed: 12,
                    onChoose: this.dragStart,
                    onStart: this.dragStart,
                    onMove: this.onDragMove,
                    onEnd: this.onDragEnd,
                    onUnchoose: this.clearDropIndicators,
                    disabled: this.sortableStatus,
                }
            )
        },

        destroyed() {
            // remove event listeners
            document.removeEventListener('keydown', this.handleShortcut)
        },

        methods: {
            
            // ============== METODI AZIONI RAPIDE ==============
            
            toggleBulkActions() {
                this.showBulkActions = !this.showBulkActions
                if (this.showBulkActions) {
                    this.initializeBulkActions()
                }
            },

            initializeBulkActions() {
                const actions = {}
                
                // Inizializza azioni per campi numerici
                this.numericFields.forEach(field => {
                    actions[field.key] = {
                        operation: 'replace',
                        value: null
                    }
                })

                // Inizializza azioni per campi select
                this.selectFields.forEach(field => {
                    actions[field.key] = {
                        selectedValue: undefined
                    }
                })

                // Inizializza azioni per campi boolean
                this.booleanFields.forEach(field => {
                    actions[field.key] = {
                        booleanValue: undefined
                    }
                })

                this.bulkActions = actions
            },

            getFieldOptions(field) {
                return field.options || []
            },

            clearAllItems() {
                if (confirm('Sei sicuro di voler eliminare tutti gli elementi?')) {
                    this.items.splice(0, this.items.length)
                    this.$store.commit('setSnackbar', {
                        timeout: 3000,
                        text: 'Tutti gli elementi sono stati eliminati',
                        value: true,
                        color: 'success'
                    })
                }
            },

            applyBulkNumericAction(fieldKey) {
                const action = this.bulkActions[fieldKey]
                const value = parseFloat(action.value)
                
                if (isNaN(value)) {
                    this.$store.commit('setSnackbar', {
                        timeout: 3000,
                        text: 'Valore non valido',
                        value: true,
                        color: 'error'
                    })
                    return
                }

                let updatedCount = 0
                this.items.forEach(item => {
                    // Skip layout elements
                    if (this.isLayoutElement(item)) return

                    const currentValue = parseFloat(item[fieldKey]) || 0
                    let newValue = currentValue

                    switch (action.operation) {
                        case 'replace':
                            newValue = value
                            break
                        case 'increment':
                            newValue = currentValue + value
                            break
                        case 'decrement':
                            newValue = currentValue - value
                            break
                        case 'increment_percent':
                            newValue = currentValue * (1 + value / 100)
                            break
                        case 'decrement_percent':
                            newValue = currentValue * (1 - value / 100)
                            break
                    }

                    // Ensure the value is not negative for certain fields
                    if (['price', 'quantity'].includes(fieldKey) && newValue < 0) {
                        newValue = 0
                    }

                    Vue.set(item, fieldKey, Number(newValue.toFixed(fieldKey === 'quantity' ? 0 : 2)))
                    updatedCount++
                })

                const operationText = this.numericOperations.find(op => op.value === action.operation)?.text || action.operation
                this.$store.commit('setSnackbar', {
                    timeout: 3000,
                    text: `${operationText} applicata a ${updatedCount} elementi`,
                    value: true,
                    color: 'success'
                })

                // Reset values
                action.value = null
            },

            applyBulkSelectAction(fieldKey) {
                const action = this.bulkActions[fieldKey]
                const selectedValue = action.selectedValue
                
                if (selectedValue === undefined || selectedValue === null) {
                    this.$store.commit('setSnackbar', {
                        timeout: 3000,
                        text: 'Seleziona un valore',
                        value: true,
                        color: 'error'
                    })
                    return
                }

                const field = this.selectFields.find(f => f.key === fieldKey)
                const selectedOption = field.options.find(opt => opt.value === selectedValue)
                
                let updatedCount = 0
                this.items.forEach(item => {
                    // Skip layout elements
                    if (this.isLayoutElement(item)) return

                    Vue.set(item, fieldKey, selectedValue)
                    if (selectedOption && selectedOption.text) {
                        Vue.set(item, fieldKey + '_text', selectedOption.text)
                    }
                    updatedCount++
                })

                this.$store.commit('setSnackbar', {
                    timeout: 3000,
                    text: `Valore aggiornato per ${updatedCount} elementi`,
                    value: true,
                    color: 'success'
                })

                // Reset values
                action.selectedValue = undefined
            },

            applyBulkBooleanAction(fieldKey) {
                const action = this.bulkActions[fieldKey]
                const booleanValue = action.booleanValue === 'true'
                
                if (action.booleanValue === undefined) {
                    this.$store.commit('setSnackbar', {
                        timeout: 3000,
                        text: 'Seleziona un valore',
                        value: true,
                        color: 'error'
                    })
                    return
                }

                let updatedCount = 0
                this.items.forEach(item => {
                    // Skip layout elements
                    if (this.isLayoutElement(item)) return

                    Vue.set(item, fieldKey, booleanValue)
                    updatedCount++
                })

                this.$store.commit('setSnackbar', {
                    timeout: 3000,
                    text: `Valore ${booleanValue ? 'Sì' : 'No'} applicato a ${updatedCount} elementi`,
                    value: true,
                    color: 'success'
                })

                // Reset values
                action.booleanValue = undefined
            },

            // ============== FINE METODI AZIONI RAPIDE ==============

            // ============== METODI PRODOTTI PERCENTUALI ==============

            /**
             * Ricalcola i prezzi dei prodotti percentuali basandosi sull'imponibile base
             */
            recalculatePercentageProducts() {
                // Calcola l'imponibile base (esclusi layout elements e percentage)
                let baseSubtotal = 0
                this.items.forEach(item => {
                    if (!this.isLayoutElement(item) && item.type !== 'percentage') {
                        baseSubtotal += this.calcItemNetPrice(item)
                    }
                })

                // Aggiorna i prezzi dei prodotti percentuali non bloccati
                this.items.forEach(item => {
                    if (item.type === 'percentage' && !item.price_locked) {
                        const percentage = parseFloat(item.quantity) || 0
                        const calculatedPrice = Math.round(((baseSubtotal * percentage / 100) + Number.EPSILON) * 100) / 100
                        Vue.set(item, 'price', calculatedPrice)
                    }
                })
            },

            /**
             * Calcola il prezzo netto di un item (usato per calcolare l'imponibile base)
             */
            calcItemNetPrice(item) {
                if (this.isLayoutElement(item) || item.type === 'percentage') return 0

                let price = parseFloat(item.price) || 0
                let quantity = parseFloat(item.quantity) || 0
                let quantity_per_pack = parseFloat(item.quantity_per_pack) || 1

                // Applica sconti di riga
                for (let j = 1; j <= 5; j++) {
                    if (typeof item['discount' + j] === 'number' && item['discount' + j] > 0) {
                        price = price * (100 - item['discount' + j]) / 100
                    }
                }

                // Applica sconto globale (escluse spese se impostazione attiva)
                const globalDiscount = this.parent && typeof this.parent.global_discount === 'number' ? this.parent.global_discount : 0
                const excludeDiscountFromExpense = this.$store.getters.checkSettings('exclude_discount_from_expense')
                if (!(excludeDiscountFromExpense && item.type === 'spesa')) {
                    price = price * (100 - globalDiscount) / 100
                }

                return Math.round(((price * quantity_per_pack * quantity) + Number.EPSILON) * 100) / 100
            },

            // ============== FINE METODI PRODOTTI PERCENTUALI ==============

            /**
             * Build URL parameters string from configuration
             * @return {string} Formatted URL parameters string
             */
             buildUrlParams() {
                // Start with empty string
                let params = []
                
                if(this.info.crudRelation.urlParams2) {
                    _.forEach(this.info.crudRelation.urlParams2, (value) => {
                        if(value.item) {
                            if (this.editedItem[value.key] !== undefined && this.editedItem[value.key] !== null) {
                                // Add param=value to array (now adding the equals sign)
                                params.push(value.param + '=' + encodeURIComponent(this.editedItem[value.key]))
                            }
                        } else {
                            if (this.parent[value.key] !== undefined && this.parent[value.key] !== null) {
                                // Add param=value to array (now adding the equals sign)
                                params.push(value.param + '=' + encodeURIComponent(this.parent[value.key]))
                            }
                        }
                    })
                }
                
                // Create URL parameters string with exactly one question mark
                let urlParams = '?'
                
                if (params.length > 0) {
                    urlParams += params.join('&')
                    urlParams += '&lite=1'
                } else {
                    urlParams += 'lite=1'
                }
                
                return urlParams
            },

            handleShortcut(e) {
                if (this.dialog) {
                    // catch ctrl + Enter when new dialog is opened and save
                    if (e.ctrlKey && !e.shiftKey && e.keyCode == 13) {
                        this.save(false)
                    }

                    // catch ctrl + shift + Enter when new dialog is opened and save and open new
                    if (e.ctrlKey && e.shiftKey && e.keyCode == 13) {
                        this.save(true)
                    }

                    // catch esc when new dialog is opened and close
                    if (e.keyCode == 27) {
                        this.close()
                    }
                }
            },

            /************************************ BARCODE **********************************/

            toggleFullScreen() {
                const card = this.$refs.dialogCard && this.$refs.dialogCard.$el
                const dialog = card && card.closest('.v-dialog')
                if (dialog) dialog.style.transform = ''
                this.fullScreen = !this.fullScreen
            },

            barcodeScannerMode() {
                this.barcodeScanner = !this.barcodeScanner
                this.resetBarcodeInputs()

                if(this.barcodeScanner) {
                    this.audioLoad = this.loadAudio('/sounds/carico.mp3')
                    this.audioError = this.loadAudio('/sounds/errore.mp3')     
                    this.$nextTick(() => {
                        if (this.$refs.barcode) {
                            this.$refs.barcode.focus()
                        }
                    })           
                }
            },

            searchProductBarcode() {
                if(this.barcode) {
                    let searchQuantity = this.parseBarcodeQuantity()
                    if(searchQuantity === null) {
                        searchQuantity = 1
                    }
                    this.axios.get('/products/searchBarcode', {params: { barcode: this.barcode, quantity: searchQuantity, lot_id: this.barcodeLot ? this.barcodeLot.value : null }}).then(response => {
                        let data = response.data
                        this.currentBarcodeProduct = data.model
                        if(data.status == 'success') {
                            this.audioLoad.play()
                            this.latestBarcodeProduct = data.model

                            if(this.currentBarcodeProduct.lots) {
                                this.$nextTick(() => {
                                    this.lotSelect.options = data.lots
                                    if (this.$refs.barcodeLot) {
                                        if(this.preselectLot && this.lotSelect.options && this.lotSelect.options[0]) {
                                            this.$set(this, 'barcodeLot', this.lotSelect.options[0])
                                        }                                        
                                        this.$refs.barcodeLot.focus()
                                    }
                                })
                            } else if(this.quantityMode) {
                                this.$nextTick(() => {
                                    if (this.$refs.quantity) {
                                        this.$refs.quantity.focus()
                                    }
                                })
                            } else {
                                if(this.pushProductBarcodeMode(1)) {
                                    this.resetBarcodeInputs()
                                }
                            }

                            this.$store.commit('setSnackbar', {timeout: 6000, text: 'Prodotto trovato', value: true, color: 'success'})

                        } else {
                            this.audioError.play()
                            this.$store.commit('setSnackbar', {timeout: 6000, text: response.data.message, value: true, color: 'error'})
                            this.barcode = ''
                        }
                    })
                }
            },

            // Normalizza il valore del campo quantità della modalità barcode.
            // Ritorna null se non è una quantità valida (vuoto, non numerico, <= 0
            // oppure fuori scala perché è stato sparato un barcode nel campo)
            parseBarcodeQuantity() {
                let raw = this.barcodeQuantity
                if (raw === null || raw === undefined) {
                    return null
                }
                raw = String(raw).trim().replace(',', '.')
                // solo decimali puri: scarta barcode alfanumerici, notazioni tipo 0x10 / 1e5, segni
                if (!/^\d+(\.\d+)?$/.test(raw)) {
                    return null
                }
                const value = Number(raw)
                if (!isFinite(value) || value <= 0 || value > this.maxBarcodeQuantity) {
                    return null
                }
                return value
            },

            resetBarcodeInputs() {
                this.barcode = ''
                this.barcodeQuantity = 1
                this.barcodeLot = null
                this.lotSelect.options = []
                // azzerare il prodotto corrente nasconde anche l'autocomplete Lotto
                this.currentBarcodeProduct = {}
            },

            pushProductBarcodeMode(quantity) {
                // il prodotto corrente deve essere un prodotto appena trovato: dopo il push
                // il suo id diventa un dummyId negativo, quindi un secondo invio va ignorato
                if (!this.currentBarcodeProduct || !this.currentBarcodeProduct.id || this.currentBarcodeProduct.id < 0) {
                    return false
                }
                const row = {
                    ...this.currentBarcodeProduct,
                    product_id: this.currentBarcodeProduct.id,
                    recurrence_type: 'one_time_only',
                    id: this.dummyId,
                    quantity: quantity,
                    lot_id: this.barcodeLot?.value,
                    lot_id_text: this.barcodeLot?.text,
                }
                delete row.lots
                // Anteprima locale del subtotal: il backend lo ricalcola al save del documento (prepareDocument)
                row.subtotal = this.calcItemNetPrice(row)
                this.dummyId--
                this.items.push(row)
                return true
            },

            /**
             * Aggiunge una riga prodotto senza aprire il dialog, usata dal
             * drawer "Storico prodotti" in inserimento/modifica ordine.
             * Replica l'autocompilazione di updateSelectText (fetch dal backend
             * con i parametri del cliente, es. listino) e accoda la riga in
             * locale con id fittizio negativo, come il flusso barcode: la
             * persistenza avviene solo al salvataggio del documento.
             * Ritorna una Promise<boolean> (true se la riga è stata aggiunta).
             */
            addProductFromHistory(productId, quantity) {
                const field = _.find(this.fieldsset.fields, (f) => { return f.key === 'product_id' })
                if(!productId || !field || !field.on_select) {
                    return Promise.resolve(false)
                }

                // riparti dal default e applica i default di campo (come addNew)
                const item = Object.assign({}, this.defaultItem)
                _.forEach(this.fieldsset.fields, (value) => {
                    if(value.default) {
                        Vue.set(item, value.key, value.default)
                    }
                })

                // set url params es company_id or supplier_id
                this.editedItem = item
                this.urlParams = this.buildUrlParams()

                return this.axios.get(field.on_select.url + '/' + productId + this.urlParams).then(response => {
                    const model = response.data.model
                    const lots = response.data?.lots?.collection

                    item.type = model.product_type

                    // Set value in response to item (come updateSelectText)
                    _.forEach(this.fieldsset.fields, (f) => {
                        if(typeof model[f.key] !== 'undefined') {
                            Vue.set(item, f.key, model[f.key])
                            if(model[f.key + '_text']) {
                                Vue.set(item, f.key + '_text', model[f.key + '_text'])
                            }
                        }
                    })

                    // Imposta sempre price e purchase_price se presenti nella risposta, anche se i campi sono nascosti
                    _.forEach(['price', 'purchase_price'], (priceField) => {
                        if(typeof model[priceField] !== 'undefined') {
                            Vue.set(item, priceField, model[priceField])
                        }
                    })

                    Vue.set(item, 'product_id', productId)
                    Vue.set(item, 'product_id_text', model.name)
                    if(!item.name) {
                        Vue.set(item, 'name', model.name)
                    }

                    // Per prodotti percentuali, imposta quantity con percentage_value
                    if(model.product_type === 'percentage') {
                        Vue.set(item, 'quantity', model.percentage_value || 0)
                        Vue.set(item, 'price', 0)
                        Vue.set(item, 'price_locked', false)
                    } else {
                        Vue.set(item, 'quantity', quantity)
                    }

                    // lotto: preseleziona il primo se il setting è attivo
                    if(this.preselectLot && lots && lots[0]) {
                        Vue.set(item, 'lot_id', lots[0].value)
                        Vue.set(item, 'lot_id_text', lots[0].text)
                        // quantità sempre positiva: il verso lo decide la direzione effettiva della riga
                        Vue.set(item, 'lot_allocations', [{ lot_id: lots[0].value, lot_id_text: lots[0].text, quantity: Math.abs(parseFloat(item.quantity)) || 0 }])
                    }

                    // Anteprima locale del subtotal: il backend lo ricalcola al save del documento (prepareDocument)
                    Vue.set(item, 'subtotal', this.calcItemNetPrice(item))
                    Vue.set(item, 'id', this.dummyId)
                    this.dummyId--
                    this.items.push(item)
                    this.editedItem = Object.assign({}, this.defaultItem)
                    return true
                }, () => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    return false
                })
            },

            addBarcodeProduct() {
                const quantity = this.quantityMode ? this.parseBarcodeQuantity() : 1
                if (quantity === null) {
                    if (this.audioError) {
                        this.audioError.play()
                    }
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: 'Quantità non valida: inserisci un numero maggiore di 0 (max ' + this.maxBarcodeQuantity + ')',
                        value: true,
                        color: 'error'
                    })
                    this.barcodeQuantity = 1
                    // il prodotto trovato resta in attesa: si tiene il focus sulla quantità
                    // così l'operatore ridigita solo il numero senza perdere la scansione
                    this.$nextTick(() => {
                        if (this.$refs.quantity) {
                            this.$refs.quantity.focus()
                            if (this.$refs.quantity.$refs.input) {
                                this.$refs.quantity.$refs.input.select()
                            }
                        }
                    })
                    return
                }
                if (!this.pushProductBarcodeMode(quantity)) {
                    return
                }
                this.resetBarcodeInputs()
                this.$nextTick(() => {
                    if (this.$refs.barcode) {
                        this.$refs.barcode.focus()
                    }
                })
            },

            loadAudio(path) {
                let audio = new Audio(path)
                audio.muted = true
                audio.play()
                audio.addEventListener('canplaythrough', event => {
                    setTimeout(() => {
                        audio.muted = false
                    }, audio.duration * 1000)
                })
                return audio
            },


            /************************************ END BARCODE **********************************/


            dragStart() {
                Vue.nextTick(() => {
                    this.expandedItems = []
                })
            },

            dragReorder ({oldIndex, newIndex}) {
                const movedItem = this.items.splice(oldIndex, 1)[0]
                this.items.splice(newIndex, 0, movedItem)
            },

            itemKey (item) {
                if (!this.itemKeys.has(item)) this.itemKeys.set(item, ++this.currentItemKey)
                return this.itemKeys.get(item)
            },

            initialize() {
                this.axios.get(this.infoUrl).then(response => {

                    this.info = response.data.info
                    this.fieldsset = response.data.fields
                    this.fieldssetDescription = response.data.fieldsDescription
                    this.defaultInput = this.info.crudRelation.defaultInput
                    this.idDescription = this.info.crudRelation.idDescription
                    // idSeparator/idPagebreak: il backend manda true come placeholder quando setting è off, id numerico quando è on
                    const rawSep = this.info.crudRelation.idSeparator
                    const rawPb = this.info.crudRelation.idPagebreak
                    const rawSub = this.info.crudRelation.idSubtotal
                    this.idSeparator = (typeof rawSep === 'number') ? rawSep : null
                    this.idPagebreak = (typeof rawPb === 'number') ? rawPb : null
                    this.idSubtotal = (typeof rawSub === 'number') ? rawSub : null

                    this.toggleWithholdingField(this.parent && this.parent.has_withholding)

                }, response => {
                    // error callback
                    var db = this.$store.getters.getDB
                    db.info_data.where('modelDef').equals(this.infoUrl.replace('-info', '')).first().then(info_response => {

                        // if there is priduct_id key build products options
                        let position = null
                        position = info_response.fields.fields.map(f => f.key).indexOf('product_id')

                        if(position >= 0) {
                            info_response.fields.fields[position].async = false
                            var db = this.$store.getters.getDB
                            let options = []
                            db.products.toArray().then((result) => {
                                _.forEach(result, (product, key) => {
                                    // take product name in products table
                                    options.push({
                                        'barcode': product.barcode,
                                        'barred': product.barred,
                                        'code': product.product_code ? product.product_code : product.code,
                                        'subtitle': product.type_text,
                                        'text': product.name,
                                        'value': product.id,
                                    })
                                })
                            })
                            info_response.fields.fields[position].options = options
                        }

                        Vue.set(this, 'info', info_response.info)
                        Vue.set(this, 'fieldsset', info_response.fields)
                        Vue.set(this, 'fieldssetDescription', info_response.fieldssetDescription)
                        Vue.set(this, 'defaultInput', info_response.defaultInput)
                        Vue.set(this, 'idDescription', info_response.idDescription)
                    })
                })
            },

            toggleWithholdingField(show) {
                if (this.fieldsset && this.fieldsset.fields) {
                    let field = this.fieldsset.fields.find(f => f.key === 'withholding')
                    if (field) {
                        Vue.set(field, 'hidden', !show)
                    }
                }
            },

            // At select product precompile inputs
            updateQuantityChange(field, quantity) {
                // set url params es company_id or supplier_id
                if(this.$store.getters.checkSettings('recalculate_price_at_changed_quantity')) {
                    this.urlParams = this.buildUrlParams();
                    
                    this.axios.get(field.on_select.url + '/' + this.editedItem.product_id  + this.urlParams).then(response => {
                        
                        this.modelForAutocomplete = response.data.model
                        this.product_warehouse = response.data.warehouses
                        this.editedItem.type = this.modelForAutocomplete.type


                        // Set defaultInput in input
                        _.forEach(this.defaultInput, (value, key) => {
                            if(value.text) {
                                Vue.set(this.editedItem, key + '_text', value.text)
                                Vue.set(this.editedItem, key, value.value)
                            } else {
                                Vue.set(this.editedItem, key, value)
                            }
                        })

                        // Set value in response to editedItem
                        _.forEach(this.fieldsset.fields, (field, k) => {
                            if(typeof field.extra_fill !== 'undefined'){
                                Vue.set(this.fieldsset.fields[k], 'options', this.modelForAutocomplete[field.extra_fill])
                                Vue.set(this.editedItem, field.extra_fill, this.modelForAutocomplete[field.extra_fill])
                            }
                            if(typeof this.modelForAutocomplete[field.key] !== 'undefined') {
                                Vue.set(this.editedItem, field.key, this.modelForAutocomplete[field.key])
                                if(this.modelForAutocomplete[field.key + '_text']) {
                                    Vue.set(this.editedItem, field.key + '_text', this.modelForAutocomplete[field.key + '_text'])
                                }
                            }
                        })
                    }, response => {
                        // error callback
                    })
                }

            },
            
            // Import on-demand dal catalogo MEF quando un codice non è tra i prodotti
            // (codice esatto: MEF interno o cod_art)
            mefCatalogImport(field, search) {
                if(!search) return

                Vue.set(field, 'mef_importing', true)

                let params = {search}
                if(this.parent && this.parent.company_id) params.company_id = this.parent.company_id

                this.axios.get('mef-products-lookup', {params}).then(response => {
                    let matches = response.data.data || []

                    if(matches.length !== 1) {
                        Vue.set(field, 'mef_importing', false)
                        this.$store.commit('setSnackbar', {
                            timeout: 6000,
                            text: matches.length
                                ? 'Più articoli MEF con questo codice: nessun prodotto importato'
                                : 'Nessun prodotto trovato nel catalogo MEF',
                            value: true,
                            color: 'warning'
                        })
                        return
                    }

                    this.axios.post('mef-products-import', {cod_arts: [matches[0].cod_art]}).then(res => {
                        Vue.set(field, 'mef_importing', false)

                        let products = res.data && res.data.data ? res.data.data.products : []
                        if(!products || !products.length) return
                        let imported = products[0]

                        // aggiungi l'opzione e seleziona il prodotto importato
                        let option = {}
                        let valueKey = field.item_value ? field.item_value : 'value'
                        let textKey = field.item_text ? field.item_text : 'text'
                        option[valueKey] = imported.product_id
                        option[textKey] = imported.name
                        option.code = imported.code
                        Vue.set(field, 'options', [option])

                        Vue.set(this.editedItem, 'product_id', imported.product_id)

                        // autocompila come una normale selezione prodotto (prezzi, magazzino, lotti)
                        this.updateSelectText(field, imported.product_id)

                        this.$store.commit('setSnackbar', {
                            timeout: 6000,
                            text: 'Prodotto importato dal catalogo MEF',
                            value: true,
                            color: 'success'
                        })
                    }, () => {
                        Vue.set(field, 'mef_importing', false)
                        this.$store.commit('setSnackbarError')
                    })
                }, () => {
                    Vue.set(field, 'mef_importing', false)
                    this.$store.commit('setSnackbarError')
                })
            },

            updateSelectText(field, id) {
                // Regole "change_other" del campo (es. potenza impegnata -> potenza disponibile), come in Create/Edit.
                // Solo quelle: gli altri tipi di target nelle righe non sono mai stati attivi
                const changeOther = (Array.isArray(field.targets) ? field.targets : []).filter(target => target.type === 'change_other')
                if (changeOther.length) {
                    this.$eventBusUtility.fieldsGeneratorConditions({ ...field, targets: changeOther }, id, this.fieldsset, this.editedItem)
                }

                // If field.key === 'product_id' ajax call for show product
                if(field.key == 'product_id') {
                    // if delete product flush warehouses and lots
                    if(!id) {
                        this.$set(this, 'product_warehouse', {})
                        this.$set(this, 'product_lot', [])
                        this.$set(this.editedItem, 'lots', false)
                        this.$set(this.editedItem, 'lot_id', null)
                        this.$set(this.editedItem, 'lot_id_text', null)
                        this.$set(this.editedItem, 'serials', false)
                        this.$set(this.editedItem, 'lot_allocations', [])
                        let lotField = _.find(this.fieldsset.fields, (f) => { return f.key == 'lot_id' })
                        if(lotField) {
                            this.$set(lotField, 'options', [])
                        }
                        return
                    }

                    if(field.on_select && id) {
                        // If add description
                        if(id === this.idDescription) {
                            this.editedItem.product_id = this.idDescription
                            this.editedItem.name = 'Descrizione'
                            this.editedItem.type = 'description'
                        } else {
                            // this.editedItem.type = 'product'
                            this.editedItem.type = '' 

                            // set url params es company_id or supplier_id
                            this.urlParams = this.buildUrlParams()
                            
                            this.axios.get(field.on_select.url + '/' + id  + this.urlParams).then(response => {
                                
                                this.modelForAutocomplete = response.data.model
                                this.product_warehouse = response.data.warehouses
                                this.product_lot = response.data?.lots?.collection
                                this.editedItem.type = this.modelForAutocomplete.product_type
                                this.$set(this.editedItem, 'serials', response.data.model ? !!response.data.model.serials : false)
                                this.$set(this.editedItem, 'lots', response.data.model ? !!response.data.model.lots : false)

                                // Per prodotti percentuali, imposta quantity con percentage_value
                                if (this.modelForAutocomplete.product_type === 'percentage') {
                                    Vue.set(this.editedItem, 'quantity', this.modelForAutocomplete.percentage_value || 0)
                                    Vue.set(this.editedItem, 'price', 0)
                                    Vue.set(this.editedItem, 'price_locked', false)
                                }

                                // cerca in fieldsset.fields il campo con key = lot_id e imposta in options this.product_lot
                                // rimandata al nextTick: i flag lots/serials appena impostati sopra pilotano il
                                // v-if="checkDepends(field)" del campo lot_allocations in FieldsGenerator, quindi
                                // l'editor deve prima montare (o rimanere smontato) prima che parta la preselezione
                                this.$nextTick(() => {
                                    this.updateLotOptions()
                                })

                                // Set defaultInput in input
                                _.forEach(this.defaultInput, (value, key) => {
                                    if(value.text) {
                                        Vue.set(this.editedItem, key + '_text', value.text)
                                        Vue.set(this.editedItem, key, value.value)
                                    } else {
                                        Vue.set(this.editedItem, key, value)
                                    }
                                })

                                // Set value in response to editedItem
                                _.forEach(this.fieldsset.fields, (field, k) => {
                                    if(typeof field.extra_fill !== 'undefined'){
                                        Vue.set(this.fieldsset.fields[k], 'options', this.modelForAutocomplete[field.extra_fill])
                                        Vue.set(this.editedItem, field.extra_fill, this.modelForAutocomplete[field.extra_fill])
                                    }
                                    if(typeof this.modelForAutocomplete[field.key] !== 'undefined') {
                                        Vue.set(this.editedItem, field.key, this.modelForAutocomplete[field.key])
                                        if(this.modelForAutocomplete[field.key + '_text']) {
                                            Vue.set(this.editedItem, field.key + '_text', this.modelForAutocomplete[field.key + '_text'])
                                        }
                                    }
                                })

                                // Imposta sempre price e purchase_price se presenti nella risposta, anche se i campi sono nascosti
                                _.forEach(['price', 'purchase_price'], (priceField) => {
                                    if(typeof this.modelForAutocomplete[priceField] !== 'undefined') {
                                        Vue.set(this.editedItem, priceField, this.modelForAutocomplete[priceField])
                                    }
                                })

                            }, response => {
                                // error callback
                                var db = this.$store.getters.getDB

                                db.products.where('id').equals(id).first().then(product => {
                                    this.modelForAutocomplete = product
                                    this.$set(this.editedItem, 'name', this.modelForAutocomplete.name)
                                    this.$set(this.editedItem, 'price', this.modelForAutocomplete.price)
                                    this.$set(this.editedItem, 'purchase_price', this.modelForAutocomplete.purchase_price)
                                    this.$set(this.editedItem, 'quantity', 1)
                                })
                            })
                        }

                    }
                } // Else if field is another field example vat and have options search text and write in editedItem
                else if(field.key == 'lot_id') {

                    // this.editedItem.type = 'product'
                    this.editedItem.type = '' 

                    // set url params es company_id or supplier_id
                    this.urlParams = this.buildUrlParams()
                    
                    this.axios.get(field.on_select.url + '/' + this.editedItem.product_id  + this.urlParams).then(response => {
                        
                        this.modelForAutocomplete = response.data.model
                        this.editedItem.type = this.modelForAutocomplete.product_type

                        // Set value in response to editedItem
                        _.forEach(['price', 'purchase_price', 'discount1', 'discount2', 'discount3', 'discount4', 'discount5', 'lots'], (field, k) => {
                            if(typeof this.modelForAutocomplete[field] !== 'undefined') {
                                Vue.set(this.editedItem, field, this.modelForAutocomplete[field])
                            }
                        })
                    }, response => {
                        // error callback
                    })

                    let optionSelected = _.find(field.options, (o) => { return o.value === id})
                    if(optionSelected) {
                        Vue.set(this.editedItem, field.key + '_text', optionSelected.text)
                    }

                }
                // cambio unità di misura: ripropone il prezzo convertito col fattore configurato sul prodotto,
                // solo se l'unità scelta è configurata sul prodotto corrente (this.modelForAutocomplete deve
                // riferirsi allo stesso prodotto della riga, non a un'altra riga); aggiorna sempre unit_text
                else if(field.key == 'unit') {
                    if(this.modelForAutocomplete && typeof this.modelForAutocomplete.price !== 'undefined' && this.modelForAutocomplete.id == this.editedItem.product_id) {
                        const units = this.modelForAutocomplete.units || []
                        const match = units.find(u => u.unit == id)

                        if(match && match.price_auto !== false) {
                            Vue.set(this.editedItem, 'price', _.round(this.modelForAutocomplete.price * match.factor, 5))
                        } else if(!match && units.length && id == this.modelForAutocomplete.unit) {
                            // ritorno all'UM base: ripropone il listino solo se il prezzo in riga
                            // è uno dei prezzi auto-calcolati (base o base×fattore con ricalcolo
                            // attivo); un prezzo digitato a mano non viene mai sovrascritto
                            const autoPrices = units.filter(u => u.price_auto !== false).map(u => _.round(this.modelForAutocomplete.price * u.factor, 5))
                            autoPrices.push(this.modelForAutocomplete.price)
                            if(autoPrices.some(v => v == this.editedItem.price)) {
                                Vue.set(this.editedItem, 'price', this.modelForAutocomplete.price)
                            }
                        }
                    }

                    let optionSelected = _.find(field.options, (o) => { return o.value === id})
                    if(optionSelected) {
                        Vue.set(this.editedItem, field.key + '_text', optionSelected.text)
                    }
                } else if(field.options) {
                    let optionSelected = _.find(field.options, (o) => { return o.value === id})
                    if(optionSelected) {
                        Vue.set(this.editedItem, field.key + '_text', optionSelected.text)
                    }
                }
                
            },

            cloneItem(index, item) {
                var newItem = JSON.parse(JSON.stringify(item))
                newItem.id = this.dummyId--
                this.items.splice(index, 0, newItem)
            },


            editItem(index, item) {
                this.editedIndex = index
                this.editedItem = JSON.parse(JSON.stringify(item))
                this.barcodeScanner = false
                this.resetBarcodeInputs()

                _.forEach(this.fieldsset.fields, (field, k) => {
                    if(typeof field.async !== 'undefined' && field.async){
                        let option = {}
                        let value_key = field.item_value ? field.item_value : 'value'
                        let text_key = field.item_text ? field.item_text : 'text'
                        option[value_key] = this.editedItem[field.key]
                        if(this.editedItem.product) {
                            option[text_key] = this.editedItem.product[field.relation_field]
                        } else {
                            option[text_key] = this.editedItem[field.relation_field]
                        }
                        if(typeof field.searchKeys !== 'undefined') {
                            _.forEach(field.searchKeys, (s) => {
                                if(this.editedItem.product) {
                                    option[s] = this.editedItem.product[s]
                                } else {
                                    option[s] = this.editedItem[s]
                                }
                            })
                        }
                        Vue.set(this.fieldsset.fields[k], 'options', [option])
                    }
                    if(typeof field.extra_fill !== 'undefined'){
                        Vue.set(this.fieldsset.fields[k], 'options', this.editedItem[field.extra_fill])
                    }
                })

                if(this.urlParams == '') {
                    this.urlParams = '?'
                } else {
                    this.urlParams += '&'
                }
                this.urlParams += 'lite=1'

                // get warehouse information in edit
                this.axios.get('products/' + this.editedItem.product_id + this.urlParams).then(response => {
                    this.product_warehouse = response.data.warehouses
                    this.product_lot = response.data?.lots?.collection

                    // Non fare auto-select del lotto quando si entra in modifica di una riga esistente:
                    // l'auto-select deve avvenire solo alla creazione di una nuova riga o al cambio prodotto
                    this.updateLotOptions(false)
                }, response => {
                    // error callback
                })

                this.dialog = true
            },
            
            deleteItem(index) {
                this.items.splice(index, 1)
            },

            addNew() {
                this.dialog = true

                // Set defaultInput by back-end
                _.forEach(this.fieldsset.fields, (value, key) => {
                    if(value.type === 'checkbox' || value.type === 'file') {
                        Vue.set(this.editedItem, value.key, '')
                    }
                    if(value.default) {
                        Vue.set(this.editedItem, value.key, value.default)
                    }
                })

                // focus on first field
                this.$nextTick(() => {
                    if (typeof this.$refs.fieldsgenerator != 'undefined' && typeof this.$refs.fieldsgenerator.$refs[this.fieldsset.fields[0].key] != 'undefined') {
                        this.$refs.fieldsgenerator.$refs[this.fieldsset.fields[0].key][0].focus()
                    }
                })
            },

            close() {
                this.dialog = false
                this.fullScreen = false
                setTimeout(() => {
                    // Empty deposit object
                    // remove colors
                    _.forEach(this.fieldsset.fields, (field, k) => {
                        if(typeof field.extra_fill !== 'undefined'){
                            Vue.set(this.fieldsset.fields[k], 'options', [])
                        }
                    })
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.product_warehouse = {}
                    this.editedIndex = -1
                }, 300)
            },

            save(openNew) {
                this.loading = true
                const lotEditor = this.getLotAllocationsEditor()
                if (lotEditor) {
                    const lotCheck = lotEditor.validate()
                    if (!lotCheck.valid) {
                        this.loading = false
                        return false
                    }
                }
			    this.customFieldPivotValidation().then((piv) => {
                    if (!piv.every((r) => r == true )) {
                        this.loading = false
                        return false
                    }                
                    this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                        if (result) {

                            // Anteprima locale del Totale rigo: il backend lo ricalcola al save del documento (prepareDocument).
                            Vue.set(this.editedItem, 'subtotal', this.calcItemNetPrice(this.editedItem))

                            // If edit, use index and update object in items
                            if (this.editedIndex > -1) {
                                Vue.set(this.items, this.editedIndex, this.editedItem)

                            } else {
                                // If new, index not needed, push new object in items
                                Vue.set(this.editedItem, 'id', this.dummyId)
                                this.dummyId--
                                this.items.push(this.editedItem)
                            }

                            this.close()

                            // reopen dialog
                            if(openNew) {
                                this.$nextTick(() => {setTimeout(() => {this.addNew()}, 300)})
                            }
                        }

                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    })
			    })                
            },

            customFieldPivotValidation() {
                let resultPromise = []
                _.forEach(this.fieldsset.fields, (f) => {
                    if(f.type === 'pivot') {
                        if(this.$refs.fieldsgenerator &&
                            this.$refs.fieldsgenerator.$refs &&
                            this.$refs.fieldsgenerator.$refs[f.key] &&
                            this.$refs.fieldsgenerator.$refs[f.key][0] &&
                            this.$refs.fieldsgenerator.$refs[f.key][0].$refs &&
                            this.$refs.fieldsgenerator.$refs[f.key][0].$refs.fieldsgeneratorpivot
                        ) {
                            _.forEach(this.$refs.fieldsgenerator.$refs[f.key][0].$refs.fieldsgeneratorpivot, (field) => {
                                resultPromise.push(field.$validator.validateAll())
                            })
                        } else {
                            return new Promise((resolve, reject) => {
                                resolve(true)
                            })
                        }
                    } else {
                        return new Promise((resolve, reject) => {
                            resolve(true)
                        })
                    }
                })
                return Promise.all(resultPromise)
            },

            onLotSelection(event) {
                if(event == null) {
                    return false
                }
                if (this.quantityMode) {
                    this.$nextTick(() => {
                        if (this.$refs.quantity) {
                            this.$refs.quantity.focus()
                        }
                    })
                } else {
                    this.addBarcodeProduct()
                }
            },

            autoselectFirstLot() {
                if (!this.preselectLot) return
                const editor = this.getLotAllocationsEditor()
                if (editor) {
                    this.$nextTick(() => {
                        editor.prefillFirstLot()
                        this.fetchPriceForSelectedLot()
                    })
                    return
                }
                if (this.product_lot &&
                    this.product_lot.length > 0) {
                    const today = new Date().toISOString().slice(0, 10)
                    const validLot = this.product_lot.find(lot =>
                        lot.stock > 0 &&
                        (!lot.expiration_date || lot.expiration_date >= today)
                    )
                    if (!validLot) return
                    this.$set(this.editedItem, 'lot_id', validLot.value)
                    this.$set(this.editedItem, 'lot_id_text', validLot.text)

                    // Dopo aver impostato il lot_id, rifai la chiamata API per ottenere il prezzo corretto
                    // basato sul lotto selezionato (stessa logica della selezione manuale del lotto)
                    this.fetchPriceForSelectedLot()
                }
            },

            // Trova l'istanza montata di LotAllocationsEditor per il campo lot_allocations.
            // Il fieldset dichiara ora un solo campo con key 'lot_allocations' (nessun
            // depends_key/depends_value, nessuna duplicazione lotti/matricole): FieldsGenerator
            // lo monta sempre, e l'editor stesso decide se rendersi visibile (model.lots o
            // model.serials). refs.lot_allocations[0] è quindi sempre l'unica istanza.
            getLotAllocationsEditor() {
                const refs = this.$refs.fieldsgenerator && this.$refs.fieldsgenerator.$refs
                if (!refs || !refs.lot_allocations || !refs.lot_allocations[0]) return null
                return refs.lot_allocations[0]
            },

            /**
             * Fetch product price based on selected lot
             * Called after autoselect lot to get the correct price for the lot
             */
            fetchPriceForSelectedLot() {
                if (!this.editedItem.product_id || !this.editedItem.lot_id) {
                    return
                }

                // Rebuild URL params now that lot_id is set
                this.urlParams = this.buildUrlParams()

                this.axios.get('products/' + this.editedItem.product_id + this.urlParams).then(response => {
                    this.modelForAutocomplete = response.data.model

                    // Update only price-related fields from the response
                    _.forEach(['price', 'purchase_price', 'discount1', 'discount2', 'discount3', 'discount4', 'discount5'], (field) => {
                        if(typeof this.modelForAutocomplete[field] !== 'undefined') {
                            Vue.set(this.editedItem, field, this.modelForAutocomplete[field])
                        }
                    })
                }, response => {
                    // error callback
                })
            },

            updateLotOptions(autoselect = true) {
                let lotField = _.find(this.fieldsset.fields, (f) => { return f.key == 'lot_id' })
                if(lotField) {
                    Vue.set(lotField, 'options', this.product_lot)
                }
                const allocationsFields = _.filter(this.fieldsset.fields, (f) => { return f.key == 'lot_allocations' })
                _.forEach(allocationsFields, (f) => {
                    Vue.set(f, 'options', this.product_lot)
                    Vue.set(f, 'row_direction', this.unloadModelNames.includes(this.fieldsset.model_name) ? 'unload' : 'load')
                    // Riferimento (non un valore snapshot) al documento padre: sui documenti
                    // di acquisto il fornitore può non essere ancora impostato quando la riga
                    // viene aperta, quindi l'editor deve leggere company_id al momento della
                    // creazione del lotto/matricola, non a quello dell'apertura del dialog.
                    Vue.set(f, 'document_parent', this.purchaseDocumentModelNames.includes(this.fieldsset.model_name) ? this.parent : null)
                })
                if((lotField || allocationsFields.length) && autoselect) {
                    this.autoselectFirstLot()
                }
            },

            // ============== DRAG-AND-DROP DROP INDICATOR ==============

            /**
             * Pulisce le classi drop-target da tutte le righe del tbody.
             */
            clearDropIndicators() {
                if (!this.$refs.sortableTable) return
                const tbody = this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0]
                if (!tbody) return
                tbody.querySelectorAll('.drop-target-above, .drop-target-below').forEach(el => {
                    el.classList.remove('drop-target-above', 'drop-target-below')
                })
            },

            /**
             * SortableJS onMove: applica una classe alla riga "over" che indica
             * dove la riga draggata verrà inserita (sopra o sotto).
             */
            onDragMove(evt) {
                this.clearDropIndicators()
                if (evt.related && evt.related.tagName === 'TR') {
                    evt.related.classList.add(evt.willInsertAfter ? 'drop-target-below' : 'drop-target-above')
                }
                return true
            },

            /**
             * SortableJS onEnd: pulisce gli indicator e delega il riordino.
             */
            onDragEnd(evt) {
                this.clearDropIndicators()
                this.dragReorder(evt)
            },

            // ============== METODI ELEMENTI DI LAYOUT ==============

            /**
             * Ritorna true se l'item è un elemento di layout (separator/description/pagebreak)
             */
            isLayoutElement(item) {
                if (!item || typeof item !== 'object') return false
                return ['separator', 'description', 'pagebreak', 'subtotal'].includes(item.type)
            },

            /**
             * Restituisce il valore order massimo tra gli items + 1
             */
            _nextLayoutOrder() {
                if (!this.items || this.items.length === 0) return 1
                return Math.max(...this.items.map(i => i.order || 0)) + 1
            },

            /**
             * Inserisce o appende un item di layout rispettando pendingInsertIndex / editingLayoutIndex.
             */
            _placeLayoutItem(item) {
                if (this.editingLayoutIndex !== null) {
                    this.items.splice(this.editingLayoutIndex, 1, item)
                } else if (this.pendingInsertIndex !== null) {
                    this.items.splice(this.pendingInsertIndex, 0, item)
                } else {
                    this.items.push(item)
                }
                this.pendingInsertIndex = null
                this.editingLayoutIndex = null
            },

            /**
             * Apre il dialog separatore. afterIndex = indice a cui inserire (null = append).
             */
            addSeparator(afterIndex = null) {
                if (!this.idSeparator) {
                    console.warn('[CrudTableRelationship] idSeparator non disponibile — setting quotation_layout_elements off?')
                    return
                }
                this.editingLayoutIndex = null
                this.pendingInsertIndex = Number.isInteger(afterIndex) ? afterIndex : null
                this.separatorInput = ''
                this.separatorDialog = true
            },

            confirmSeparator() {
                if (!this.separatorInput.trim()) return
                const base = this.editingLayoutIndex !== null ? this.items[this.editingLayoutIndex] : {}
                const item = {
                    ...base,
                    id: base.id || this.dummyId--,
                    product_id: this.idSeparator,
                    type: 'separator',
                    name: this.separatorInput.trim(),
                    description: null,
                    quantity: 0,
                    price: 0,
                    order: base.order || this._nextLayoutOrder(),
                }
                this._placeLayoutItem(item)
                this.separatorDialog = false
                this.separatorInput = ''
            },

            addSubtotal(afterIndex = null) {
                if (!this.idSubtotal) {
                    console.warn('[CrudTableRelationship] idSubtotal non disponibile — setting quotation_layout_elements off?')
                    return
                }
                this.editingLayoutIndex = null
                this.pendingInsertIndex = Number.isInteger(afterIndex) ? afterIndex : null
                this.subtotalInput = ''
                this.subtotalDialog = true
            },

            confirmSubtotal() {
                const base = this.editingLayoutIndex !== null ? this.items[this.editingLayoutIndex] : {}
                const item = {
                    ...base,
                    id: base.id || this.dummyId--,
                    product_id: this.idSubtotal,
                    type: 'subtotal',
                    // Titolo opzionale (es. "Subtotale Opzione A"); fallback "Subtotale" in render.
                    name: this.subtotalInput.trim() || null,
                    description: null,
                    quantity: 0,
                    price: 0,
                    order: base.order || this._nextLayoutOrder(),
                }
                this._placeLayoutItem(item)
                this.subtotalDialog = false
                this.subtotalInput = ''
            },

            /**
             * Somma progressiva mostrata su una riga subtotale: imponibile netto delle righe
             * dal subtotale precedente fino a (escluso) questo. calcItemNetPrice ritorna 0 per
             * layout element e percentage, quindi quelle righe non contribuiscono (coerente col PDF).
             */
            calcSubtotalForRow(index) {
                let sum = 0
                for (let i = index - 1; i >= 0; i--) {
                    const it = this.items[i]
                    if (!it) continue
                    if (it.type === 'subtotal') break
                    sum += this.calcItemNetPrice(it)
                }
                return Math.round((sum + Number.EPSILON) * 100) / 100
            },

            /**
             * Range [start..end] del blocco delimitato dalla riga subtotale a `subtotalIndex`:
             * start = riga dopo il subtotale precedente (o 0), end = il subtotale stesso.
             */
            _blockRange(subtotalIndex) {
                let start = 0
                for (let i = subtotalIndex - 1; i >= 0; i--) {
                    if (this.items[i] && this.items[i].type === 'subtotal') { start = i + 1; break }
                }
                return { start, end: subtotalIndex }
            },

            /**
             * Apre il dialog di conferma per eliminare un intero blocco/opzione (prodotti sopra
             * il subtotale, fino al subtotale precedente, + il marker subtotale).
             */
            requestDeleteBlock(index) {
                const sub = this.items[index]
                if (!sub || sub.type !== 'subtotal') return
                const { start, end } = this._blockRange(index)
                let count = 0
                for (let i = start; i < end; i++) {
                    if (this.items[i] && !this.isLayoutElement(this.items[i])) count++
                }
                this.blockDeleteInfo = { start, end, count, label: sub.name || 'Subtotale' }
                this.blockDeleteDialog = true
            },

            confirmDeleteBlock() {
                if (!this.blockDeleteInfo) { this.blockDeleteDialog = false; return }
                const { start, end } = this.blockDeleteInfo
                this.items.splice(start, end - start + 1)
                this.blockDeleteDialog = false
                this.blockDeleteInfo = null
            },

            addDescription(afterIndex = null) {
                if (!this.idDescription) {
                    console.warn('[CrudTableRelationship] idDescription non disponibile — setting quotation_layout_elements off?')
                    return
                }
                this.editingLayoutIndex = null
                this.pendingInsertIndex = Number.isInteger(afterIndex) ? afterIndex : null
                this.descriptionInput = ''
                this.descriptionTitleInput = ''
                this.descriptionDialog = true
            },

            confirmDescription() {
                if (!this.descriptionDialogValid) return
                const base = this.editingLayoutIndex !== null ? this.items[this.editingLayoutIndex] : {}
                const title = (this.descriptionTitleInput || '').trim()
                const item = {
                    ...base,
                    id: base.id || this.dummyId--,
                    product_id: this.idDescription,
                    type: 'description',
                    name: title || null,
                    description: this.descriptionInput,
                    quantity: 0,
                    price: 0,
                    order: base.order || this._nextLayoutOrder(),
                }
                this._placeLayoutItem(item)
                this.closeDescriptionDialog()
            },

            closeDescriptionDialog() {
                this.descriptionDialog = false
                this.descriptionInput = ''
                this.descriptionTitleInput = ''
                this.editingLayoutIndex = null
                this.pendingInsertIndex = null
            },

            addPagebreak(afterIndex = null) {
                if (!this.idPagebreak) {
                    console.warn('[CrudTableRelationship] idPagebreak non disponibile — setting quotation_layout_elements off?')
                    return
                }
                const item = {
                    id: this.dummyId--,
                    product_id: this.idPagebreak,
                    type: 'pagebreak',
                    name: null,
                    description: null,
                    quantity: 0,
                    price: 0,
                    order: this._nextLayoutOrder(),
                }
                this.editingLayoutIndex = null
                this.pendingInsertIndex = Number.isInteger(afterIndex) ? afterIndex : null
                this._placeLayoutItem(item)
            },

            /**
             * Toggle del flag "nascondi in stampa" sulla riga prodotto. Il valore viene
             * salvato a lato backend come campo pivot product_quotation.hide_in_pdf.
             * I prodotti nascosti restano nel calcolo totali/costi ma sono esclusi dal PDF.
             */
            toggleHideInPdf(item) {
                if (!item || item.type === 'pagebreak') return
                this.$set(item, 'hide_in_pdf', !item.hide_in_pdf)
            },

            /**
             * Apre il dialog corretto in modalità edit per l'item di layout a `index`.
             */
            editLayoutElement(index, item) {
                if (!item || item.type === 'pagebreak') return
                this.editingLayoutIndex = index
                this.pendingInsertIndex = null
                if (item.type === 'separator') {
                    this.separatorInput = item.name || ''
                    this.separatorDialog = true
                } else if (item.type === 'description') {
                    this.descriptionTitleInput = item.name || ''
                    this.descriptionInput = item.description || ''
                    this.descriptionDialog = true
                } else if (item.type === 'subtotal') {
                    this.subtotalInput = item.name || ''
                    this.subtotalDialog = true
                }
            },

            /**
             * True per la PRIMA colonna non-meta (drag/number/actions) — usata per il colspan del contenuto layout.
             */
            isLayoutContentCell(header, headers) {
                const meta = ['actions', 'drag', 'number']
                if (meta.includes(header.value)) return false
                const firstData = headers.find(h => !meta.includes(h.value))
                return !!firstData && firstData.value === header.value
            },

            layoutContentColspan(headers) {
                const meta = ['actions', 'drag', 'number']
                return headers.filter(h => !meta.includes(h.value)).length
            },

            // ============== FINE METODI ELEMENTI DI LAYOUT ==============
        }
    }
</script>
<style scoped>
    .handle {
        cursor: move !important;
        cursor: -webkit-grabbing !important;
    }

    .drag-disabled {
        color: rgba(0,0,0,0.26) !important;
    }

    ::v-deep .description-content img {
        max-width: 100%;
        height: auto;
        display: block;
    }

    ::v-deep .expanded-description-row:hover {
        background: inherit !important;
    }

    .row-editing td {
        background-color: rgba(25, 118, 210, 0.10) !important;
    }

    .layout-element-row td {
        border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
    }

    .layout-element-content {
        padding: 6px 12px !important;
    }

    .layout-element-drag {
        padding: 0 8px !important;
    }

    ::v-deep .layout-description-preview p {
        margin-bottom: 0 !important;
        display: inline;
    }

    ::v-deep .layout-description-preview img {
        max-height: 20px;
        width: auto;
    }

    /* Cella azioni: bottoni sempre su una riga, non si wrappano */
    .actions-cell {
        display: inline-flex;
        align-items: center;
        flex-wrap: nowrap;
    }

    /* Hover riga: match index aziende (.enhanced-table) — quasi invisibile.
       Esclude le righe in stato sortable per non sovrascrivere lo stile drag-and-drop. */
    ::v-deep .v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):not(.sortable-ghost):not(.sortable-chosen):not(.sortable-drag) {
        background-color: rgba(var(--v-primary-base), 0.04) !important;
    }

    /* Drag handle: hover invita all'interazione */
    ::v-deep .handle:hover .v-icon {
        color: var(--v-primary-base) !important;
    }

    /* Stile drag-and-drop SortableJS — feedback visivo durante il riordino righe */
    ::v-deep .sortable-ghost {
        opacity: 0.35 !important;
        background-color: rgba(var(--v-primary-base), 0.06) !important;
        outline: 2px dashed rgba(var(--v-primary-base), 0.6);
        outline-offset: -2px;
    }
    ::v-deep .sortable-chosen {
        cursor: grabbing !important;
    }
    ::v-deep .sortable-drag {
        opacity: 0.95 !important;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18) !important;
        border-radius: 4px;
    }

    /* Drop indicator: linea che mostra dove la riga verrà droppata */
    ::v-deep tr.drop-target-above td {
        box-shadow: inset 0 2px 0 0 var(--v-primary-base);
        transition: box-shadow 120ms ease;
    }
    ::v-deep tr.drop-target-below td {
        box-shadow: inset 0 -2px 0 0 var(--v-primary-base);
        transition: box-shadow 120ms ease;
    }

    /* Nei dialog il fab va sotto il bordo della card (nel margine mb-12),
       altrimenti copre le azioni dell'ultima riga. Deve battere la regola
       !important di capacitor-safe-areas.css (3 classi > 2). */
    .v-btn--fab.v-btn--bottom.crud-add-fab--in-dialog {
        bottom: calc(-44px + env(safe-area-inset-bottom, 0px)) !important;
    }

</style>